import { render, staticRenderFns } from "./SliderBase.vue?vue&type=template&id=3687edec&"
import script from "./SliderBase.vue?vue&type=script&lang=ts&"
export * from "./SliderBase.vue?vue&type=script&lang=ts&"
import style0 from "./SliderBase.vue?vue&type=style&index=0&id=3687edec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports